module.exports = __webpack_public_path__ + "img/open_in_new.1a2377dc.svg";